import styled, { Color, css, FontSize } from '../../config/theme'

export interface CommonProps {
  color?: Color
  align?: 'center' | 'flex-start' | 'flex-end' | 'space-between'
  size?: FontSize
}

const common = css<CommonProps>`
  color: ${props => props.theme.color[props.color || 'gray']};

  display: flex;
  justify-content: ${props => !props.align ? 'flex-start' : props.align};
  align-items: center;

  ${props => props.size && `font-size: ${props.theme.fontSize[props.size]};`}

  word-break: break-word;

  +, > {
    span,
    p,
    h1,
    h2 {
      margin-left: 5px;
    }
  }
`

const span = styled.span<CommonProps>`
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;

  ${common}
`

const p = styled.p<CommonProps>`
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;

  ${common}
`
const b = styled.b<CommonProps>`
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;

  ${common}
`

const h1 = styled.h1<CommonProps>`
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;

  ${common}
`

const h2 = styled.h2<CommonProps>`
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;

  ${common}
`

const mapToComponent = {
  span,
  p,
  b,
  h1,
  h2,
}

export { mapToComponent, }

